export const FORM_STATUS_PICKER = {
  TITLE: 'Choose Project Status',
  DESCRIPTION: 'Please select a desired status for your research study upon approval by the REACH BC Office.',
};
